import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';
import { useStyles } from './EventStyle';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#5B6773',
    color:'#ffffff',
    height: 52,
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 16,
    paddingLeft: 30
  },
  body: {
    fontSize: 14,
    height: 52,
    color: '#5B6773',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 16,
    paddingLeft: 30
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#F4F6F8',
    },
  },
}))(TableRow);

function createData(name) {
  return { name};
}

const rows = [
  createData('1'),
  createData('2'),
  createData('3'),
  createData('4'),
  createData('5'),
  createData('6'),
  createData('7'),
  createData('8'),

];


export default function Event() {
  const classes = useStyles();

  return (
  <>
      <Typography
        variant="h6"
        component="div"
        noWrap={true}
        className={classes.eventText}
      >
        Project Event Log
      </Typography>
      <TableContainer component={Paper} className={classes.eventContainer}  style={{ borderRadius: 12 }}>
        <Table className={classes.table} size="medium" aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Timestamp (UTC)</StyledTableCell>
              <StyledTableCell >User</StyledTableCell>
              <StyledTableCell align="left">Description</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <StyledTableRow key={row.name}>
                <StyledTableCell style={{ width: 366 }} component="th" scope="row">
                  {'2022-03-28  02:47:05 UTC'}
                </StyledTableCell>
                <StyledTableCell style={{ width: 300 }}>{'omarfarukuiuxupwork1820@.io'}</StyledTableCell>
                <StyledTableCell >{'2022-03-28  02:47:05 UTC'}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>

  );
}
